import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExchange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 18,
	viewBox: "0 0 25 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.7365 2.86627L8.89355 2.86627L8.89355 6.44915L19.7365 6.44915L19.7365 9.31543L24.7525 4.6577L19.7365 -3.80177e-05L19.7365 2.86627Z",
		fill: "#FF3131"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.98082 15.1337L16.8237 15.1337L16.8237 11.5509L5.98082 11.5509L5.98082 8.68457L0.964792 13.3423L5.98081 18L5.98082 15.1337Z",
		fill: "#85A0AD"
	})]
});
export default SvgExchange;
